import { apiFetch } from './apiFetch';

export interface ClassCatalog {
  class_names: string[];
  locations: string[];
}

/** Distinct class names + locations (recent window) for the per-class bonus pickers. */
export function getClassCatalog(): Promise<ClassCatalog> {
  return apiFetch<ClassCatalog>('/class-catalog');
}

export interface CategoryCatalogEntry {
  /** Arbox box_category_group_id. */
  id: number | null;
  name: string;
  class_names: string[];
}

/** One recurring class ("series"), at its latest slot. series_id is null only
 *  for a one-off class, grouped by slot. */
export interface SeriesCatalogEntry {
  series_id: number | null;
  class_name: string;
  location: string;
  weekday: number;
  start_time: string;
  series_name: string | null;
  meetings: number;
  staff_ids: number[];
}

export interface RateCatalog {
  categories: CategoryCatalogEntry[];
  series: SeriesCatalogEntry[];
}

/** The box's קטגוריות + recurring class slots, read off recent meetings. */
export function getRateCatalog(): Promise<RateCatalog> {
  return apiFetch<RateCatalog>('/class-catalog/rate-targets');
}
